(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["drop-product-scripts"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.drop-product__form').forEach((form) => {
    if (form.dataset.qtyBound) return;
    form.dataset.qtyBound = 'true';
    const input = form.querySelector('input[name="quantity"]');
    if (!input) return;
    form.querySelectorAll('[data-qty-change]').forEach((button) => {
      button.addEventListener('click', () => {
        const delta = Number(button.dataset.qtyChange || 0);
        input.value = String(Math.max(1, (Number(input.value) || 1) + delta));
      });
    });
  });

  document.querySelectorAll('.drop-product__media-col').forEach((col) => {
    if (col.dataset.galleryBound) return;
    const gallery = col.querySelector('.drop-product__gallery');
    const strip = col.querySelector('.drop-product__thumbs');
    const thumbs = col.querySelectorAll('.drop-product__thumb');
    const prev = col.querySelector('.drop-product__arrow--prev');
    const next = col.querySelector('.drop-product__arrow--next');
    if (!gallery || !strip || !thumbs.length) return;
    col.dataset.galleryBound = 'true';

    let current = 0;

    const setActive = (index) => {
      current = index;
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
        if (i === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= thumbs.length - 1;
      const active = thumbs[index];
      if (active && strip.scrollWidth > strip.clientWidth) {
        strip.scrollTo({
          left: active.offsetLeft - (strip.clientWidth - active.offsetWidth) / 2,
          behavior: 'smooth',
        });
      }
    };

    const goTo = (index) => {
      const target = Math.max(0, Math.min(thumbs.length - 1, index));
      gallery.scrollTo({ left: target * gallery.clientWidth, behavior: 'smooth' });
      setActive(target);
    };

    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => goTo(i)));
    if (prev) prev.addEventListener('click', () => goTo(current - 1));
    if (next) next.addEventListener('click', () => goTo(current + 1));

    let ticking = false;
    gallery.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          const width = gallery.clientWidth || 1;
          const index = Math.round(gallery.scrollLeft / width);
          if (index !== current) setActive(index);
        });
      },
      { passive: true }
    );

    setActive(0);
  });
  } catch(e) { console.error(e); }
})();

})();
